module.exports = __webpack_public_path__ + "media/images/uncheck-5f774f5a66b2450debe7fb50ba4c80b8.png";